import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { setInitialAuthState } from '../redux/actions/authActions';
import { readProfile } from '../utils/authUtils';
import PrivateLayout from './PrivateLayot';

const PrivateRouter = ({ userData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accessToken = readProfile()?.accessToken;

  const isAuthenticated = useMemo(() => {
    return (userData, accessToken) => {
      return userData && accessToken;
    };
  }, []);

  useEffect(() => {
    if (!isAuthenticated(userData, accessToken)) {
      dispatch(setInitialAuthState(navigate));
    }
  }, [dispatch, navigate, isAuthenticated, accessToken, userData]);

  return isAuthenticated(userData, accessToken) ? <PrivateLayout userData={userData} /> : <Navigate to="/login" />;
};

export default PrivateRouter;
